import { connect } from 'react-redux';
import CodeFirstLanding from './code-first-landing.component';
import { goToLoginPage } from '../login/login.actions';
import { IRedeemCodeFormat } from '@sitegen/common/types/redemption.types';
import { Dispatch } from 'types/dispatch';
import { savePlatformType, saveRedeemCode } from '../redemption/redemption.actions';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { State } from 'widgets/redeem/root/root.reducers';
import { WIDGET_NAME } from '@sitegen/common/constants';

const mapStateToProps = (state: State): ICodeFirstLandingStoreProps => ({
    fetching: state.login.fetching,
    codeFormat: state.config.RSCodeFormat,
    widgetName: state.config.widgetName
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToLoginPage: (): void => {
        dispatch(goToLoginPage());
    },
    saveRedeemCode: (code: string): void => {
        dispatch(saveRedeemCode(code));
    },
    savePlatformType: (platformId: PLATFORM_TYPES): void => {
        dispatch(savePlatformType(platformId));
    }
});

const CodeFirstLandingContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CodeFirstLanding);

export interface ICodeFirstLandingDispatchProps {
    readonly goToLoginPage: typeof goToLoginPage;
    readonly saveRedeemCode: typeof saveRedeemCode;
    readonly savePlatformType: typeof savePlatformType;
}

export interface ICodeFirstLandingStoreProps {
    readonly fetching: boolean;
    readonly codeFormat: IRedeemCodeFormat;
    readonly widgetName: WIDGET_NAME;
}

export default CodeFirstLandingContainer;
